import React, {useContext} from 'react';
import { Routes, Route, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';

import Menu from './Menu';
import HeaderBody from './HeaderBody';
import Footer from './Footer';
import Ingreso from '../pages/Ingreso';
import Salir from '../pages/Salir';

// PAGINAS
import Home from '../pages/Home';
import Notificaciones from '../pages/Notificaciones';
import NotificacionForm from '../pages/NotificacionForm';
import NotificacionShow from '../pages/NotificacionShow';
import NotificacionesNotificador from '../pages/NotificacionesNotificador';
import UsuarioForm from '../pages/UsuarioForm';
import Cedulas from '../pages/Cedulas';
import CedulaForm from '../pages/CedulaForm';
import CambioClave from '../pages/CambioClave';
import RecuperoClave from '../pages/RecuperClave';
import ActivarUsuario from '../pages/ActivarUsuario';
import Usuarios from '../pages/Usuarios';
import Admin from '../pages/Admin';
import Pdf from '../pages/Pdf';
import RegistroPdfForm from '../pages/RegistroPdfForm';
import RegistroUsuario from '../pages/RegistroUsuario';
import RegistroDeObligados from '../pages/RegistroDeObligados';
import ApoderadoForm from '../pages/ApoderadoForm';
import Obligados from '../pages/Obligados';
import ObligadoForm from '../pages/ObligadoForm';
import DeclaracionJuradaForm from '../pages/DeclaracionJuradaForm';
import RegistroPublicoObligado from '../pages/RegistroPublicoObligado';

import Ayuda from '../pages/Ayuda';

const Body = () => {
  let { status } = useParams();
  const [authInformation, setAuthInformation, showSideMenu, setShowSideMenu] = useContext(InputContext)

  return (
    <div className={`g-sidenav-show bg-gray-100 ${showSideMenu ? 'g-sidenav-pinned' : ''}`}>
      <aside className={`sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 ${showSideMenu ? 'bg-white' : 'left-menu'}`} id="sidenav-main">
        <Menu />
      </aside>

      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <HeaderBody />
        <div className="container-fluid py-4">

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pdf" element={<Pdf />} />
            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/ayuda" element={<Ayuda />} />
            <Route path="/cambioClave" element={<CambioClave />} />
            <Route path="/recuperoClave/:token" element={<RecuperoClave />} />
            <Route path="/recuperoClave" element={<RecuperoClave />} />
            <Route path="/activarUsuario/:token" element={<ActivarUsuario />} />
            <Route path="/activarUsuario" element={<ActivarUsuario />} />

            <Route path="/registroUsuario" element={<RegistroUsuario />} />
            <Route path="/registroPdfForm" element={<RegistroPdfForm />} />
            <Route path="/registro" element={<RegistroDeObligados />} />
            <Route path="/obligados" element={<Obligados />} />
            <Route path="/obligadoForm/:id" element={<ObligadoForm />} />
            <Route path="/declaracionJuradaForm/new" element={<DeclaracionJuradaForm />} />
            {/* <Route path="/declaracionJuradaForm/:id" element={<DeclaracionJuradaForm />} /> */}
            <Route path="/registroPublico" element={<RegistroPublicoObligado />} />
            <Route path="/cedulas" element={<Cedulas />} />
            <Route path="/cedulaForm" element={<CedulaForm />} />
            <Route path="/cedulaForm/:id" element={<CedulaForm />} />           
            

            <Route path="/registroPdfForm/:id" element={<RegistroPdfForm />} />
            <Route path="/usuarioForm" element={<UsuarioForm />} />
            <Route path="/usuarioForm/:id" element={<UsuarioForm />} />

            <Route path="/apoderadoForm" element={<ApoderadoForm />} />

            <Route path="/notificaciones" element={<Notificaciones />} />
            <Route path="/notificaciones/:status" element={<Notificaciones />} />
            <Route path="/notificacion/:id/edit" element={<NotificacionForm />} />
            <Route path="/notificacion/:id" element={<NotificacionShow />} />
            <Route path="/notificacion" element={<NotificacionForm />} />
            <Route path="/notificaciones-notificador" element={<NotificacionesNotificador />} />
            <Route path="/ingreso" element={<Ingreso />} />
            <Route path="/salir" element={<Salir />} />
          </Routes>

          <Footer />
        </div>
      </main>
    </div>
  );
};

export default Body;